import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobelightroomComponent } from './simple-icons-adobelightroom.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobelightroomComponent ],
    exports:      [ SimpleIconsAdobelightroomComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobelightroomModule {}
